module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/title/title-news-c0745e469fbd4be9be06819c2b5edaf2.svg&quot;;"